import styled from 'styled-components';

export const ErrorBoxContainer = styled.section`
  height: 50vh;
  display: flex;
  padding-top: 20px;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;

  & h1 {
    margin: 10px;
    font-size: 3em;
  }

  & div {
    display: flex;
    margin: 10px;
  }

  & a {
    background: #ef4e5e;
    padding: 6px 10px;
    color: #fff;
    border-radius: 14px;
    margin: 10px;
    cursor: pointer;
    min-width: 145px;

    @media (max-width: 720px) {
      cursor: auto;
    }
  }
`;
